import { select, on, addClass } from 'helpers/dom'

const selectors = {
  BUTTON_CLOSE_SELECTOR: '.js-close-message-banner',
  HIDDEN_CLASS: 'hidden'
}

class MessageBanner extends HTMLElement {
  constructor() {
    super()

    this.buttonCloseEl = select(selectors.BUTTON_CLOSE_SELECTOR, this)
    this.hideMessageBanner()
  }

  hideMessageBanner() {
    on(
      'click',
      () => {
        addClass(selectors.HIDDEN_CLASS, this)
      },
      this.buttonCloseEl
    )
  }
}

if (!customElements.get('message-banner')) {
  customElements.define('message-banner', MessageBanner)
}
